<dt-modal-content (closeClick)="close()">
  <ng-template #title>
    @if (data.video) {
      <ng-container i18n>Video bearbeiten</ng-container>
    } @else {
      <ng-container i18n>Video hinzufügen</ng-container>
    }
  </ng-template>
  <ng-template #content>
    <form [formGroup]="formGroup" (ngSubmit)="save()">
      <mat-form-field>
        <mat-label i18n>Name</mat-label>
        <input matInput type="text" formControlName="name" />
      </mat-form-field>
      <mat-form-field>
        <mat-label i18n>YouTube ID</mat-label>
        <input matInput type="text" formControlName="youtubeId" />
        @if (formGroup.controls.youtubeId.errors?.['already-exists']) {
          <mat-error i18n>Das Video existiert schon</mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label i18n>Startzeit</mat-label>
        <input matInput type="number" formControlName="startTime" />
        @if (formGroup.controls.startTime.errors?.['invalid-start-time']) {
          <mat-error i18n>Die Zeit muss positiv sein</mat-error>
        }
      </mat-form-field>
      @if (formGroup.controls.youtubeId.value !== '') {
        <iframe
          [src]="'https://www.youtube-nocookie.com/embed/' + formGroup.controls.youtubeId.value | safeUrl"
          frameborder="0"
          allow="encrypted-media"
          allowfullscreen
        ></iframe>
      }
      <mat-form-field subscriptSizing="dynamic">
        <mat-label i18n>Schritt</mat-label>
        <mat-select formControlName="stepNumbers" multiple>
          @for (_ of [].constructor(numberOfSteps); track _; let stepIdx = $index) {
            <mat-option [value]="stepIdx" i18n>Schritt {{ stepIdx + 1 }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label i18n>Themengebiete</mat-label>
        <mat-select formControlName="categoryIds" multiple>
          @for (category of data.categories; track category) {
            <mat-option [value]="category.id">{{ category.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div class="button-wrapper">
        <button
          mat-raised-button
          color="primary"
          type="submit"
          [dtOverlayProgress]="formGroup.disabled"
          [disabled]="formGroup.disabled || formGroup.invalid"
          i18n
          >Speichern</button
        >
        <button mat-stroked-button type="reset" [disabled]="formGroup.disabled" (click)="close()" i18n>Verwerfen</button>
        @if (data.video) {
          <button mat-stroked-button type="button" color="warn" [disabled]="formGroup.disabled" (click)="delete()" i18n
            >Video löschen</button
          >
        }
      </div>
    </form>
  </ng-template>
</dt-modal-content>
